import * as React from 'react';
import clsx from 'clsx';
import { Base } from '../../Base';
import Svg from '../../Svg';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "TypoListItem-root_3DYZa",
  "iconWrapper": "TypoListItem-iconWrapper_Zlm7Y",
  "icon": "TypoListItem-icon_3F-Kh"
};
function ListItem({
  icon,
  iconTheme,
  iconProps,
  children,
  className,
  ...extraProps
}) {
  const theme = icon ? {
    flex: true,
    listStyleType: 'none'
  } : {};
  return /*#__PURE__*/_jsxs(Base, {
    tagName: "li",
    className: clsx(styles.root, className),
    ...theme,
    ...extraProps,
    children: [icon && Svg.has(icon) && /*#__PURE__*/_jsx(Base, {
      tagName: "span",
      flex: true,
      flexAlignItemsCenter: true,
      className: styles.iconWrapper,
      children: /*#__PURE__*/_jsx(Svg, {
        name: icon,
        theme: iconTheme,
        className: styles.icon,
        ...iconProps
      })
    }), children]
  });
}
ListItem.displayName = 'TypoListItem';
export { ListItem };